// polyfills to support IE 9 and friends
import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';

import React from 'react';
import { createRoot } from 'react-dom/client';
import { Routes, Route, BrowserRouter as Router } from 'react-router-dom';

import './i18n';
import ConfigureHTTPHeaders from './ConfigureHTTPHeaders';
import SignIn from './sign_in/SignIn';
import Welcome from './sign_in/Welcome';
import Invitation from './sign_in/Invitation';
import RequestAccountSuccess from './sign_in/RequestAccountSuccess';
import SignOut from './sign_out/SignOut';
import Dashboard from './Dashboard';
import Reservations from './reservation_components/Reservations';
import Reservation from './ride_view_components/rideView';
import Invoices from './invoice_components/Invoices';
import RequestApp from './request_apps/RequestApp';
import InvitePrincipal from './request_apps/principal/invitePrincipal';
import InviteAssistant from './request_apps/assistant/inviteAssistant';
import InvitePilot from './request_apps/pilot/invitePilot';
import ManageCreditCards from './credit_cards/ManageCreditCards';
import PickupCalculator from './pickup_calc/pickupCalc';
import PasswordSuccess from './password/PasswordSuccess';
import ResetPassword from './password/ResetPassword';
import ChangePassword from './password/ChangePassword';
import ForgotPassword from './password/ForgotPassword';
import IncorrectURL from './components/redirect_components/incorrectURL';
import Footer from './components/footer_components/FRFooter';
import FRHeader from './components/header_components/FRHeader';
import SmartBanner from 'react-smartbanner';

import './index.scss';
import './browserIE.scss';
import * as serviceWorker from './serviceWorker';

import ReactGA from 'react-ga';
import 'react-smartbanner/dist/main.css';

// NOTE: The 'polyfill' folder does not exist in this repo. You need to download
// the babel-polyfill package and import it at the very top of this file.

if (process.env.NODE_ENV === 'production') {
  ReactGA.initialize('UA-50495033-5');
}

class ClientPortal extends React.Component {
  constructor(props) {
    super(props);

    ConfigureHTTPHeaders();
    const currentUser = JSON.parse(localStorage.getItem('user'));
    this.state = { user: currentUser };
  }

  componentDidMount() {
    ReactGA.pageview(window.location.pathname + window.location.search);
  }

  routing = (
    <Router key="1">
      <FRHeader />
      <Routes>
        <Route path="/reservations/:reservationId" element={<Reservation />} />
        <Route path="/" element={<Dashboard />} />
        <Route path="/reservations" element={<Reservations />} />
        <Route path="/invoices" element={<Invoices />} />
        <Route path="/sign-in" element={<SignIn />} />
        <Route path="/request-account-success" element={<RequestAccountSuccess />} />
        <Route path="/welcome" element={<Welcome />} />
        <Route path="/invitation" element={<Invitation />} />
        <Route path="/password/success" element={<PasswordSuccess />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/change-password" element={<ChangePassword />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/sign-out" element={<SignOut />} />
        <Route path="/apps/principal" element={<InvitePrincipal />} />
        <Route path="/apps/assistant" element={<InviteAssistant />} />
        <Route path="/apps/pilot" element={<InvitePilot />} />
        <Route path="/apps" element={<RequestApp />} />
        <Route path="/pick-up-calculator" element={<PickupCalculator />} />
        <Route path="/credit-cards" element={<ManageCreditCards />} />
        <Route path="*" element={<IncorrectURL />} />
      </Routes>
    </Router>
  );

  render() {
    return [this.routing, <Footer key="2" />, <SmartBanner title={'Fortis Assistant App'} key="3" />];
  }
}

const root = createRoot(document.getElementById('root'));
root.render(<ClientPortal />);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
